function canvasToBlob(canvas: HTMLCanvasElement): Promise<Blob> {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error('canvas.toBlob failed'));
            }
        });
    });
}

/**
 * ObjectURL 帮助类
 */
export const objectURLHelper = {
    /** 销毁 object url */
    revoke(url = '') {
        if (objectURLHelper.isBlob(url)) {
            try {
                URL.revokeObjectURL(url);
            } catch (e) {
                console.log(e);
            }
        }
    },
    /** 创建 object url */
    async create(canvas: HTMLCanvasElement) {
        const blob = await canvasToBlob(canvas);
        return URL.createObjectURL(blob);
    },

    isHttp(url = '') {
        return url.startsWith('http');
    },

    isBlob(url = '') {
        return url.startsWith('blob:');
    },
};
